import axios from "axios";
import { get } from "lodash";
import { navigateTo } from "./navigation";
import store from "../store";
import { logoutUser } from "../slices/userSlice";

const APIV2 = axios.create({
  baseURL: process.env.REACT_APP_KIKO_API_BASE_URL_V2,
  headers: {
    "access-control-allow-origin": "*",
    "content-type": "application/json",
    desktop: true,
  },
});
APIV2.interceptors.request.use(
  (config) => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      if (token && !config.headers.authorization) {
        config.headers.authorization = `${token}`;
      }
    } catch (e) {

    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
APIV2.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const err = get(error, "response.data.error", "");
    if (
      get(err, "code", "") === 401 &&
      get(err, "stack", "") === "Unauthorized access"
    ) {
      userLogout();
    }
    return Promise.reject(error);
  }
);

const userLogout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("cart");
  localStorage.removeItem("sellerDetails");
  localStorage.removeItem("slug");
  store.dispatch(logoutUser());
  navigateTo("/");
};


export default APIV2;
